var _style, _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49, _defs50, _defs51, _defs52, _defs53, _defs54, _defs55, _defs56, _defs57, _defs58, _rect2, _defs59, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKpi2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175.2 163.5",
    style: {
      enableBackground: "new 0 0 175.2 163.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{clip-path:url(#SVGID_00000043458275352826401350000006796366476040236930_);}\n\t.st2{clip-path:url(#SVGID_00000102526825622294069930000010620839851639877761_);fill:#808080;}\n\t.st3{clip-path:url(#SVGID_00000132800428711689312130000005316444174956776861_);}\n\t.st4{clip-path:url(#SVGID_00000012470167995871319620000013531923721571562899_);fill:#808080;}\n\t.st5{clip-path:url(#SVGID_00000072992323090444759450000004784543779854081416_);}\n\t.st6{clip-path:url(#SVGID_00000132046787662945438480000001524863894501299857_);fill:#808080;}\n\t.st7{clip-path:url(#SVGID_00000064349728762969274050000008027427720470352301_);}\n\t.st8{clip-path:url(#SVGID_00000052782999643617926860000016083632152262356105_);fill:#808080;}\n\t.st9{clip-path:url(#SVGID_00000049186806870796300440000011977372951529122234_);}\n\t.st10{clip-path:url(#SVGID_00000098217569178638715220000016537900540340320434_);fill:#808080;}\n\t.st11{clip-path:url(#SVGID_00000041282749115351069040000010599902083036818351_);}\n\t.st12{clip-path:url(#SVGID_00000065767950818726561250000017526701022319503755_);fill:#808080;}\n\t.st13{clip-path:url(#SVGID_00000106136208956349144800000013896236720591824819_);}\n\t.st14{clip-path:url(#SVGID_00000131357171866862940570000007033076063085862059_);fill:#808080;}\n\t.st15{clip-path:url(#SVGID_00000085250526535585807430000015638057234778501779_);}\n\t.st16{clip-path:url(#SVGID_00000049917091911380937970000007186416042684242832_);fill:#808080;}\n\t.st17{clip-path:url(#SVGID_00000077320114839406078440000012966681832625358526_);}\n\t.st18{clip-path:url(#SVGID_00000163056851208625982270000017914967945573162915_);fill:#808080;}\n\t.st19{clip-path:url(#SVGID_00000050622337196702832440000013654366618055619717_);}\n\t.st20{clip-path:url(#SVGID_00000072994971689147864190000003950448756074615947_);fill:#808080;}\n\t.st21{clip-path:url(#SVGID_00000011030150608616438150000004804711988587187340_);}\n\t.st22{clip-path:url(#SVGID_00000056404813995793883610000012198406873754622123_);fill:#808080;}\n\t.st23{clip-path:url(#SVGID_00000128468555795110753400000013059150473381874848_);}\n\t.st24{clip-path:url(#SVGID_00000029023832777492689460000007546170245139469190_);fill:#808080;}\n\t.st25{clip-path:url(#SVGID_00000132053438627524951440000005772290671837028507_);}\n\t.st26{clip-path:url(#SVGID_00000101076150454944548250000002460975525707856027_);fill:#808080;}\n\t.st27{clip-path:url(#SVGID_00000172441766755676343260000000646492340986043533_);}\n\t.st28{clip-path:url(#SVGID_00000113321578318298899500000017020774151458610100_);fill:#808080;}\n\t.st29{clip-path:url(#SVGID_00000147917313231221813550000003285140169747846580_);}\n\t.st30{clip-path:url(#SVGID_00000016050487844164640160000012661362188479962774_);fill:#808080;}\n\t.st31{clip-path:url(#SVGID_00000117652168184889682800000012154627851660616857_);}\n\t.st32{clip-path:url(#SVGID_00000057835603518608414220000002884632943282801564_);fill:#808080;}\n\t.st33{clip-path:url(#SVGID_00000088838400415424384410000006970291628975488148_);}\n\t.st34{clip-path:url(#SVGID_00000051375816024363172860000014768357138921566892_);fill:#808080;}\n\t.st35{clip-path:url(#SVGID_00000041268145170386136720000010634092401237341872_);}\n\t.st36{clip-path:url(#SVGID_00000030487453368126170800000015147895563006281103_);fill:#808080;}\n\t.st37{clip-path:url(#SVGID_00000163038815674587437780000007652954329464294807_);}\n\t.st38{clip-path:url(#SVGID_00000027568132971537602270000010909885154148931255_);fill:#808080;}\n\t.st39{clip-path:url(#SVGID_00000102517403682210237310000009855579491761615011_);}\n\t.st40{clip-path:url(#SVGID_00000135681387247934756760000006111248203919751587_);fill:#808080;}\n\t.st41{clip-path:url(#SVGID_00000026122536441606389690000015728398558922343096_);}\n\t.st42{clip-path:url(#SVGID_00000119105900259415908790000012580047964191580065_);fill:#808080;}\n\t.st43{clip-path:url(#SVGID_00000166668859564265762760000017319100174763902382_);}\n\t.st44{clip-path:url(#SVGID_00000173847327842141596770000012824700651168608654_);fill:#808080;}\n\t.st45{clip-path:url(#SVGID_00000001634675579525201090000008474018072595992731_);}\n\t.st46{clip-path:url(#SVGID_00000181065336186144568220000008263250964311505081_);fill:#808080;}\n\t.st47{clip-path:url(#SVGID_00000123437414635251344700000002086537485504537218_);}\n\t.st48{clip-path:url(#SVGID_00000018938599945928236360000007946432269014706617_);fill:#808080;}\n\t.st49{clip-path:url(#SVGID_00000034805466810872894100000014322130708130142877_);}\n\t.st50{clip-path:url(#SVGID_00000116211291452354901150000011943679836195528618_);fill:#808080;}\n\t.st51{clip-path:url(#SVGID_00000136390690998663606840000015552409771896551857_);}\n\t.st52{clip-path:url(#SVGID_00000160874334823270217800000017721496739753995949_);fill:#808080;}\n\t.st53{clip-path:url(#SVGID_00000079471092232985209460000015257485917403363489_);}\n\t.st54{clip-path:url(#SVGID_00000091006986198610960190000002915619391120906396_);fill:#808080;}\n\t.st55{clip-path:url(#SVGID_00000105400272412599892100000009651722635865007788_);}\n\t.st56{clip-path:url(#SVGID_00000032620387906365196190000018191571557884810417_);fill:#808080;}\n\t.st57{enable-background:new    ;}\n\t.st58{fill:none;stroke:#808080;stroke-width:1.2;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 173,
    height: 128,
    xlinkHref: "AF2EE7E3E312892B.png",
    transform: "matrix(1 0 0 1 1.5997 24.1403)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 24.1,
    className: "st0",
    width: 173,
    height: 128
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M30.2,76c-0.4-2.5-2.5-4.5-5.2-4.5c-2.9,0-5.2,2.3-5.2,5.2c0,2.9,2.3,5.2,5.2,5.2c2.6,0,4.8-1.9,5.2-4.5 h8.9c0.1-0.5,0.2-1,0.4-1.5H30.2z M25,80.5c-2,0-3.7-1.7-3.7-3.7c0-2,1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7 C28.7,78.8,27.1,80.5,25,80.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014591830722055117700000009230970600912993942_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000014591830722055117700000009230970600912993942_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000055664733383862354180000013996950223813856688_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180364641662571579890000001779714787757299369_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055664733383862354180000013996950223813856688_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 70.5,
    style: {
      clipPath: "url(#SVGID_00000180364641662571579890000001779714787757299369_)",
      fill: "#808080"
    },
    width: 21.6,
    height: 12.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000095321727986036914840000017936773359277736847_",
    d: "M25,81.5c-2.6,0-4.7-2.1-4.7-4.7c0-2.6,2.1-4.7,4.7-4.7 c2.3,0,4.3,1.7,4.7,4l0.1,0.4h9c0,0.2-0.1,0.3-0.1,0.5h-8.9l-0.1,0.4C29.3,79.8,27.3,81.5,25,81.5 M25,72.6 c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2C29.2,74.4,27.3,72.6,25,72.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112632290348511629270000016294063825625877663_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095321727986036914840000017936773359277736847_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000112632290348511629270000016294063825625877663_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000168810627012455554910000015112869437597540005_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108287318820746128990000016228706959846164128_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168810627012455554910000015112869437597540005_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.3,
    y: 71.1,
    style: {
      clipPath: "url(#SVGID_00000108287318820746128990000016228706959846164128_)",
      fill: "#808080"
    },
    width: 20.5,
    height: 11.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000096770441599937670320000010258730770033198505_",
    d: "M146,77.5c0.4,2.5,2.5,4.5,5.2,4.5 c2.9,0,5.2-2.3,5.2-5.2c0-2.9-2.3-5.2-5.2-5.2c-2.6,0-4.8,1.9-5.2,4.5h-9.2c0.1,0.5,0.2,1,0.4,1.5H146z M151.2,73.1 c2,0,3.7,1.7,3.7,3.7c0,2-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7C147.5,74.7,149.1,73.1,151.2,73.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144317377173356168000000002441396991583699586_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096770441599937670320000010258730770033198505_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000144317377173356168000000002441396991583699586_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000139994501380907648830000009832654928543196582_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000167367877970123668510000017316192640775782278_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139994501380907648830000009832654928543196582_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135.8,
    y: 70.6,
    style: {
      clipPath: "url(#SVGID_00000167367877970123668510000017316192640775782278_)",
      fill: "#808080"
    },
    width: 21.6,
    height: 12.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000072268852750900632760000005127979647246661255_",
    d: "M151.2,81.5c-2.3,0-4.3-1.7-4.7-4l-0.1-0.4h-8.9 c0-0.2-0.1-0.3-0.1-0.5h9l0.1-0.4c0.3-2.3,2.3-4,4.7-4c2.6,0,4.7,2.1,4.7,4.7C155.9,79.4,153.8,81.5,151.2,81.5 M151.2,72.6 c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2c2.3,0,4.2-1.9,4.2-4.2C155.4,74.4,153.5,72.6,151.2,72.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168802314209070312020000001086932416245459328_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072268852750900632760000005127979647246661255_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000168802314209070312020000001086932416245459328_)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000146495291223022673600000008678186660867362980_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078017449924253076060000007031094960782500276_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146495291223022673600000008678186660867362980_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 136.4,
    y: 71.1,
    style: {
      clipPath: "url(#SVGID_00000078017449924253076060000007031094960782500276_)",
      fill: "#808080"
    },
    width: 20.5,
    height: 11.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000100369391729476836410000001400164247915340735_",
    d: "M25,75.5c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.2,1.3,1.2 s1.3-0.6,1.3-1.2C26.3,76.1,25.7,75.5,25,75.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031198676356913125130000011797358780677735336_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100369391729476836410000001400164247915340735_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000031198676356913125130000011797358780677735336_)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000054969687197775890170000005154979541351061668_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096737817231030779140000011938031659628445583_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054969687197775890170000005154979541351061668_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 74.5,
    style: {
      clipPath: "url(#SVGID_00000096737817231030779140000011938031659628445583_)",
      fill: "#808080"
    },
    width: 4.5,
    height: 4.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000084502014399029986190000007583480561328885920_",
    d: "M25,77.5c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7 c0.4,0,0.7,0.3,0.7,0.7C25.8,77.2,25.4,77.5,25,77.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152249337368100114210000006928399934795414712_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000084502014399029986190000007583480561328885920_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152249337368100114210000006928399934795414712_)"
    }
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000120543983319705264340000002562584135819709885_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142173279952605117260000004949081081770856085_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120543983319705264340000002562584135819709885_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 23.3,
    y: 75,
    style: {
      clipPath: "url(#SVGID_00000142173279952605117260000004949081081770856085_)",
      fill: "#808080"
    },
    width: 3.5,
    height: 3.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000056401416650993543020000016973778827505007522_",
    d: "M7.6,106.2h33.5c-0.2-0.5-0.4-1-0.5-1.5h-33"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134971729192799215270000005467536882612767162_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056401416650993543020000016973778827505007522_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000134971729192799215270000005467536882612767162_)"
    }
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000069359008350709716290000017426076541622162588_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001658746099307315110000008114566381977195955_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069359008350709716290000017426076541622162588_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 98.4,
    style: {
      clipPath: "url(#SVGID_00000001658746099307315110000008114566381977195955_)",
      fill: "#808080"
    },
    width: 34.5,
    height: 14
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000108277023463710374970000008229375720144084152_",
    d: "M23.6,104.7l0.1,0.4h16.6c0.1,0.2,0.1,0.3,0.2,0.5H23.6 l-0.1,0.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116940186901527335480000010023349487924883607_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108277023463710374970000008229375720144084152_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000116940186901527335480000010023349487924883607_)"
    }
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000024709657253171664540000006590522034873263027_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000058560493178923021920000001095152588819741856_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024709657253171664540000006590522034873263027_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.6,
    y: 99,
    style: {
      clipPath: "url(#SVGID_00000058560493178923021920000001095152588819741856_)",
      fill: "#808080"
    },
    width: 29.8,
    height: 13
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000128470977429990365290000000874094052159002024_",
    d: "M167.3,104.7h-31.7c-0.2,0.5-0.4,1-0.5,1.5h32.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165913707531806512730000015715332294055578509_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128470977429990365290000000874094052159002024_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000165913707531806512730000015715332294055578509_)"
    }
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000135682395409369839180000002980573545902124951_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073698578811971717980000001426057498984985529_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135682395409369839180000002980573545902124951_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.1,
    y: 98.4,
    style: {
      clipPath: "url(#SVGID_00000073698578811971717980000001426057498984985529_)",
      fill: "#808080"
    },
    width: 33.2,
    height: 14
  }))), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000160869812951385074060000000714793801971464599_",
    d: "M152.6,106.1l-0.1-0.4h-16.8c0.1-0.2,0.1-0.3,0.2-0.5 h16.6l0.1-0.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155852933785876049040000011744494742444762045_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160869812951385074060000000714793801971464599_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000155852933785876049040000011744494742444762045_)"
    }
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000171679642336795412190000006552873672426159795_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015315417554650716520000007106337043837031597_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171679642336795412190000006552873672426159795_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.8,
    y: 99,
    style: {
      clipPath: "url(#SVGID_00000015315417554650716520000007106337043837031597_)",
      fill: "#808080"
    },
    width: 29.8,
    height: 13
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000033358267285175122990000004006558339359829383_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178902698330903856100000006866918553892109708_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033358267285175122990000004006558339359829383_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000022544332267257374790000003149456627955920564_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086654862375513225800000014453749999978274478_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022544332267257374790000003149456627955920564_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000027595932303230131290000009023347329897112740_",
    d: "M133.6,88.4c0-25-20.4-45.4-45.5-45.4 C63,43,42.6,63.4,42.6,88.4s20.4,45.4,45.5,45.4C113.2,133.8,133.6,113.4,133.6,88.4 M44.5,88.4c0-24,19.6-43.6,43.6-43.6 c24.1,0,43.6,19.5,43.6,43.6c0,24-19.6,43.6-43.6,43.6C64,132,44.5,112.4,44.5,88.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112597164042522671790000017658628308865922465_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000027595932303230131290000009023347329897112740_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000112597164042522671790000017658628308865922465_)"
    }
  }, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000163787670755393926500000005327305658419736472_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141442107538685365060000000802903910526850458_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163787670755393926500000005327305658419736472_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.6,
    y: 42,
    style: {
      clipPath: "url(#SVGID_00000141442107538685365060000000802903910526850458_)",
      fill: "#808080"
    },
    width: 92.9,
    height: 92.8
  }))), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000108290723018234183640000001764612704083717275_",
    d: "M88.1,133.3c-24.8,0-45-20.1-45-44.9 c0-24.7,20.2-44.9,45-44.9s45,20.1,45,44.9C133.1,113.2,112.9,133.3,88.1,133.3 M88.1,44.3C63.8,44.3,44,64.1,44,88.4 c0,24.3,19.8,44.1,44.1,44.1s44.1-19.8,44.1-44.1C132.3,64.1,112.5,44.3,88.1,44.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036940349877946973650000009852014746626633151_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108290723018234183640000001764612704083717275_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036940349877946973650000009852014746626633151_)"
    }
  }, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000157310417456743467340000001261163263669623724_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077284794901281211350000001105945122219847349_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157310417456743467340000001261163263669623724_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 42.2,
    y: 42.5,
    style: {
      clipPath: "url(#SVGID_00000077284794901281211350000001105945122219847349_)",
      fill: "#808080"
    },
    width: 91.9,
    height: 91.8
  }))), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000078008843648979278560000000809069742471414944_",
    d: "M97.2,36.7l0.2-1.2c-6.3-1.1-12.9-1.1-19.1,0.1l0.2,1.2 C84.6,35.7,91,35.7,97.2,36.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157990527973836914800000009631259162830619268_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078008843648979278560000000809069742471414944_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000157990527973836914800000009631259162830619268_)"
    }
  }, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000069378311368523215140000007902273822791631033_",
    x: 78.3,
    y: 34.7,
    width: 19.1,
    height: 3.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163048152310934394680000002499167232046223796_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069378311368523215140000007902273822791631033_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 77.3,
    y: 33.7,
    style: {
      clipPath: "url(#SVGID_00000163048152310934394680000002499167232046223796_)",
      fill: "#808080"
    },
    width: 21.1,
    height: 4.1
  }))), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000088109120762137648320000000258218573809402544_",
    d: "M78.9,36c3-0.5,6.1-0.8,9.2-0.8c2.9,0,5.8,0.2,8.7,0.7 l0,0.2c-2.8-0.5-5.7-0.7-8.6-0.7c-3.1,0-6.2,0.3-9.2,0.8L78.9,36z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113319393584864045020000010613572277116894608_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088109120762137648320000000258218573809402544_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000113319393584864045020000010613572277116894608_)"
    }
  }, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000024684458066669926550000011377319646868765080_",
    x: 78.9,
    y: 34.7,
    width: 17.9,
    height: 3.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033344623921036797230000016559658879828605885_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024684458066669926550000011377319646868765080_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 34.2,
    style: {
      clipPath: "url(#SVGID_00000033344623921036797230000016559658879828605885_)",
      fill: "#808080"
    },
    width: 19.9,
    height: 3
  }))), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005976971606466700720000014802069571712008077_",
    d: "M70.5,38.9l-0.4-1.2c-15.3,5.4-27.6,17.8-32.9,33.1 l1.2,0.4C43.6,56.3,55.6,44.2,70.5,38.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043421364533460247910000015511352572469037960_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005976971606466700720000014802069571712008077_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000043421364533460247910000015511352572469037960_)"
    }
  }, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070813370455439753260000010355212016584445835_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110454767543204000620000002543624851409741503_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070813370455439753260000010355212016584445835_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 36.8,
    style: {
      clipPath: "url(#SVGID_00000110454767543204000620000002543624851409741503_)",
      fill: "#808080"
    },
    width: 35.3,
    height: 35.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000036944848543955169390000008627742716636073646_",
    d: "M37.9,70.5c5.3-14.8,17.2-26.7,31.9-32.1l0.1,0.2 c-14.7,5.4-26.5,17.3-31.8,32L37.9,70.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015313187367438446620000001429948754676014757_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036944848543955169390000008627742716636073646_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000015313187367438446620000001429948754676014757_)"
    }
  }, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000136401126186832755210000012288408463539687832_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029041830445168419230000015594202834853997709_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136401126186832755210000012288408463539687832_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.9,
    y: 37.4,
    style: {
      clipPath: "url(#SVGID_00000029041830445168419230000015594202834853997709_)",
      fill: "#808080"
    },
    width: 34,
    height: 34.1
  }))), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000027576241480181901660000015871799860986119608_",
    d: "M34.7,81.7c-0.3,2.2-0.4,4.5-0.4,6.7 c0,4.2,0.5,8.5,1.5,12.6l1.2-0.3c-1-4-1.4-8.1-1.4-12.3c0-2.2,0.1-4.4,0.4-6.6L34.7,81.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113323344635636921290000016853513584207647410_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000027576241480181901660000015871799860986119608_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000113323344635636921290000016853513584207647410_)"
    }
  }, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000075849625931827085530000008459312614379606154_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085952960144771329650000012700651065735838850_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075849625931827085530000008459312614379606154_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.3,
    y: 80.7,
    style: {
      clipPath: "url(#SVGID_00000085952960144771329650000012700651065735838850_)",
      fill: "#808080"
    },
    width: 4.7,
    height: 21.3
  }))), /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000115515455278390243840000011570324876665752737_",
    d: "M36.2,100.3c-0.9-3.9-1.3-7.9-1.3-11.9 c0-2.1,0.1-4.1,0.4-6.2l0.2,0c-0.2,2-0.4,4.1-0.4,6.1c0,4,0.4,8,1.3,11.9L36.2,100.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155827645738783081390000001819011794477236379_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115515455278390243840000011570324876665752737_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000155827645738783081390000001819011794477236379_)"
    }
  }, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000004512699937946956180000003110193616671580595_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178183327571227095110000008416837232140829569_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000004512699937946956180000003110193616671580595_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.8,
    y: 81.2,
    style: {
      clipPath: "url(#SVGID_00000178183327571227095110000008416837232140829569_)",
      fill: "#808080"
    },
    width: 3.5,
    height: 20.1
  }))), /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000116210185700962244410000008751564790420566160_",
    d: "M68.9,138.6l0.4-1.1c-12.7-4.8-23.2-14.7-28.9-27 l-1.1,0.5C45.1,123.6,55.9,133.6,68.9,138.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118368901329843696810000003008345872596414396_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116210185700962244410000008751564790420566160_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000118368901329843696810000003008345872596414396_)"
    }
  }, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000046331794516636091510000007761056575781549747_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080204040473646548090000012510513606766182074_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046331794516636091510000007761056575781549747_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.3,
    y: 109.5,
    style: {
      clipPath: "url(#SVGID_00000080204040473646548090000012510513606766182074_)",
      fill: "#808080"
    },
    width: 32,
    height: 30.1
  }))), /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000033352984452577069890000000115141880467855797_",
    d: "M68.6,137.9C56.1,133,45.8,123.3,40,111.3l0.2-0.1 c5.7,12,16.1,21.7,28.5,26.6L68.6,137.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102507794310240729860000013089741219539414962_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033352984452577069890000000115141880467855797_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000102507794310240729860000013089741219539414962_)"
    }
  }, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000170988931885398757100000010410905573858313356_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081623624519715890370000010662188261000964744_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170988931885398757100000010410905573858313356_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 110.2,
    style: {
      clipPath: "url(#SVGID_00000081623624519715890370000010662188261000964744_)",
      fill: "#808080"
    },
    width: 30.7,
    height: 28.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000129192519505855001350000001725128969060697998_",
    d: "M105.8,37.8l-0.4,1.2c14.9,5.3,26.9,17.4,32.1,32.3 l1.2-0.4C133.4,55.6,121.1,43.2,105.8,37.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124849797671810887220000015331003805455579787_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129192519505855001350000001725128969060697998_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000124849797671810887220000015331003805455579787_)"
    }
  }, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000157282218479479839160000012913254116542666152_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083799776554783214210000004039233779436937915_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157282218479479839160000012913254116542666152_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 104.4,
    y: 36.8,
    style: {
      clipPath: "url(#SVGID_00000083799776554783214210000004039233779436937915_)",
      fill: "#808080"
    },
    width: 35.3,
    height: 35.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000183953416210493938180000004686222678851311758_",
    d: "M137.9,70.6c-5.3-14.7-17.1-26.6-31.8-32l0.1-0.2 c14.7,5.4,26.6,17.3,31.9,32.1L137.9,70.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016075166707826866820000005911703699227873175_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183953416210493938180000004686222678851311758_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016075166707826866820000005911703699227873175_)"
    }
  }, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000147194555779692881460000012056969264569453464_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081612092436035515690000015164519327486568081_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147194555779692881460000012056969264569453464_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.1,
    y: 37.5,
    style: {
      clipPath: "url(#SVGID_00000081612092436035515690000015164519327486568081_)",
      fill: "#808080"
    },
    width: 34,
    height: 34.1
  }))), /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152245011381474524920000015838320457357245609_",
    d: "M140.2,101c1-4.1,1.5-8.3,1.5-12.6 c0-2.3-0.1-4.5-0.4-6.7l-1.2,0.1c0.3,2.2,0.4,4.4,0.4,6.6c0,4.1-0.5,8.3-1.4,12.3L140.2,101z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026155817484816804640000011823635786019612583_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152245011381474524920000015838320457357245609_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000026155817484816804640000011823635786019612583_)"
    }
  }, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000047779363558010829010000004253527747065482924_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039832713551993463270000003410291882916008601_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047779363558010829010000004253527747065482924_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 80.7,
    style: {
      clipPath: "url(#SVGID_00000039832713551993463270000003410291882916008601_)",
      fill: "#808080"
    },
    width: 4.7,
    height: 21.3
  }))), /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000123414615089503608230000015164064506873897105_",
    d: "M139.6,100.3c0.9-3.9,1.3-7.9,1.3-11.9 c0-2.1-0.1-4.1-0.4-6.1l0.2,0c0.2,2,0.4,4.1,0.4,6.2c0,4-0.5,8-1.3,11.9L139.6,100.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028311922715476122290000007047993833098068869_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123414615089503608230000015164064506873897105_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000028311922715476122290000007047993833098068869_)"
    }
  }, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036214534067195731080000014804296411120745133_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010992351776707025360000011113648329117143738_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036214534067195731080000014804296411120745133_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138.6,
    y: 81.2,
    style: {
      clipPath: "url(#SVGID_00000010992351776707025360000011113648329117143738_)",
      fill: "#808080"
    },
    width: 3.5,
    height: 20.1
  }))), /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000135658811323548773580000010391889668338754186_",
    d: "M106.6,137.4l0.4,1.1c13-4.9,23.8-15,29.6-27.6l-1.1-0.5 C129.9,122.8,119.3,132.6,106.6,137.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042695805008748877350000007851809436640962455_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135658811323548773580000010391889668338754186_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000042695805008748877350000007851809436640962455_)"
    }
  }, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000020371084370135382940000001625621291093652414_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168115992322601134610000001873220815061736120_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020371084370135382940000001625621291093652414_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.6,
    y: 109.5,
    style: {
      clipPath: "url(#SVGID_00000168115992322601134610000001873220815061736120_)",
      fill: "#808080"
    },
    width: 32,
    height: 30.1
  }))), /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000076587041702653613030000015133924088042688141_",
    d: "M107.3,137.7c12.4-4.9,22.8-14.5,28.5-26.6l0.2,0.1 c-5.8,12.1-16.2,21.8-28.6,26.7L107.3,137.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061446651085071949740000008993648754063184567_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076587041702653613030000015133924088042688141_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000061446651085071949740000008993648754063184567_)"
    }
  }, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000113341014335740368970000013500284991552592008_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008125151475357316470000010324521231759597737_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113341014335740368970000013500284991552592008_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 106.3,
    y: 110.2,
    style: {
      clipPath: "url(#SVGID_00000008125151475357316470000010324521231759597737_)",
      fill: "#808080"
    },
    width: 30.7,
    height: 28.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000057122325578407941570000003142432145760357052_",
    d: "M96.2,141.5l-0.2-1.2c-5.3,0.8-10.9,0.8-16.3-0.1 l-0.2,1.2c2.8,0.5,5.7,0.7,8.6,0.7C90.8,142.1,93.5,141.9,96.2,141.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139263075463186057730000011126112704085350296_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057122325578407941570000003142432145760357052_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139263075463186057730000011126112704085350296_)"
    }
  }, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114071121688562886130000011582384588079990956_",
    x: 79.5,
    y: 138.6,
    width: 16.6,
    height: 3.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060011401377490630830000010880445021645165996_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114071121688562886130000011582384588079990956_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 139.2,
    style: {
      clipPath: "url(#SVGID_00000060011401377490630830000010880445021645165996_)",
      fill: "#808080"
    },
    width: 18.6,
    height: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000151503619748508016090000007142197079841763972_",
    d: "M88.1,141.6c-2.7,0-5.4-0.2-8-0.6l0-0.2 c2.6,0.4,5.3,0.6,8,0.6c2.5,0,5-0.2,7.4-0.5l0,0.2C93.1,141.4,90.6,141.6,88.1,141.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142156599256291448100000009152743612079684527_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151503619748508016090000007142197079841763972_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000142156599256291448100000009152743612079684527_)"
    }
  }, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000066484431000546807680000010244953650379768718_",
    x: 80.1,
    y: 138.6,
    width: 15.5,
    height: 3.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076573319218274378850000010191531315015837576_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066484431000546807680000010244953650379768718_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 79.1,
    y: 139.8,
    style: {
      clipPath: "url(#SVGID_00000076573319218274378850000010191531315015837576_)",
      fill: "#808080"
    },
    width: 17.5,
    height: 2.8
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 34.1,
    className: "st0",
    width: 162.3,
    height: 108
  })), /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000075864816258222597410000010224560226283221178_",
    x: 3.5,
    y: 13.9,
    width: 82,
    height: 37
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134960571514141380140000010996205068297685433_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075864816258222597410000010224560226283221178_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000134960571514141380140000010996205068297685433_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 82,
    height: 37,
    xlinkHref: "AF2EE7E3E312892E.png",
    transform: "matrix(1 0 0 1 3.5208 13.8885)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st57"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st58",
    points: "74.8,38.8 74.8,12.6 12.9,12.6  "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpi2);
export default __webpack_public_path__ + "static/media/kpi-2.4bff37c6a425c9f0cc6315a35343ced3.svg";
export { ForwardRef as ReactComponent };